<!-- Main sidebar -->
<div class="sidebar sidebar-dark sidebar-main sidebar-expand-lg sidebar-main-resized" id="sidebarExpand">

	<!-- Sidebar content -->
	<div class="sidebar-content">

		<!-- Sidebar header -->
		<div class="sidebar-section">
			<div class="sidebar-section-body d-flex justify-content-center">
				<h5 class="sidebar-resize-hide flex-grow-1 my-auto">Navigation</h5>
				<div class="header-btn-group">
					<button type="button" class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent d-inline-flex" *ngIf="roles.includes('ADMIN')" (click)="togglePopup()">
						<i class="ph-info text-white"></i>
					</button>
					<button type="button" class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-control sidebar-main-resize d-none d-lg-inline-flex" (click)="menuExpandColapse()">
						<i class="ph-arrows-left-right"></i>
					</button>

					<button type="button" class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent d-lg-none" aria-label="Close navigation" (click)="closeMobileSidebar()">
						<i class="ph-x"></i>
					</button>
				</div>
			</div>
		</div>
		<!-- /sidebar header -->

		<!-- Main navigation -->
		<div class="sidebar-section">
			<ul class="nav nav-sidebar" data-nav-type="accordion">
				
				<li class="nav-item">
					<a [routerLink]="['/home']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-house"></i>
						<span>Home</span>
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/project']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-file-code"></i>
						<span>Projects</span>
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/data']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-database"></i>
						<span>Data</span>
					</a>
				</li>
				
				<!-- <li class="nav-item">
					<a [routerLink]="['/usecase']" class="nav-link" routerLinkActive="active">
						<i class="ph-graph"></i>
						<span>Use Case</span>
					</a>
				</li> -->
				<li class="nav-item">
					<a [routerLink]="['/block']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-cube"></i>
						<span>Blocks</span>
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/flow']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-flow-arrow"></i>
						<span>Flows</span>
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/model-registry']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-package"></i>
						<span>Model Registry</span>
					</a>
				</li>
				<li class="nav-item" *ngIf="can('FLOW_EXECUTE')">
					<a [routerLink]="['/workflows']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-play-circle"></i>
						<span>Execution FrontPage</span>
					</a>
				</li>
				<li class="nav-item" *ngIf="can('FLOW_EXECUTE')">
					<a [routerLink]="['/shared-links']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-share-network"></i>
						<span>Shared Links</span>
					</a>
				</li>
				<li class="nav-item" *ngIf="can('FLOW_EXECUTE')">
					<a [routerLink]="['/category']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-browser"></i>
						<span>Category</span>
					</a>
				</li>

				<!-- <li class="nav-item nav-item-submenu" id="nav-item-submenu">
					<a href="#" class="nav-link">
						<i class="ph-package"></i>
						<span>Model Execution</span>
					</a>
					<ul class="nav-group-sub collapse" id="nav-group-sub">
						<li class="nav-item">
							<a [routerLink]="['/model-work-flow']" class="nav-link"><i class="ph-tree-structure"></i>Model Workflow</a>
						</li>
						<li class="nav-item">
							<a [routerLink]="['/model-registry']" class="nav-link" routerLinkActive="active"><i class="ph-book"></i>Model Registry</a>
						</li>
					</ul>
				</li> -->

				

				<li class="nav-item nav-item-submenu" id="nav-item-submenu">
					<a href="#" class="nav-link">
						<i class="ph-dots-three-outline"></i>
						<span>Master</span>
					</a>
					<ul class="nav-group-sub collapse" id="nav-group-sub">
						<!-- <li class="nav-item">
							<a [routerLink]="['/category']" class="nav-link"><i class="ph-browser"></i>Categories</a>
						</li> -->
						<li class="nav-item">
							<a [routerLink]="['/image-registry']" class="nav-link" routerLinkActive="active"><i class="ph-disc"></i>Image Registry</a>
						</li>
						<li class="nav-item">
							<a [routerLink]="['/streamlit']" class="nav-link" routerLinkActive="active">
								<i class="ph-chart-bar"></i>
								<span>Streamlit</span>
							</a>
						</li>
						<!-- <li class="nav-item">
							<a [routerLink]="['/market']" class="nav-link" routerLinkActive="active">Market Place</a>
						</li> -->
					</ul>
				</li>

				<li class="nav-item nav-item-submenu" id="nav-item-submenu">
					<a href="#" class="nav-link">
						<i class="ph-gear"></i>
						<span>Management</span>
					</a>
					<ul class="nav-group-sub collapse" id="nav-group-sub">
						<li class="nav-item" *ngIf="can('ACTIVE_USERS_VIEW')">
							<a [routerLink]="['/active-users']" class="nav-link" routerLinkActive="active"> <i class="ph-user-focus"></i>Active Users</a>
						</li>
						<li class="nav-item">
							<a [routerLink]="['/approval-request']" class="nav-link" routerLinkActive="active">
								<i class="ph-check-circle"></i>Approvals
							</a>
						</li>
						<li class="nav-item">
							<a [routerLink]="['/audit-logs']" class="nav-link" routerLinkActive="active"><i class="ph-file"></i>Audit Logs</a>
						</li>
						
						<li class="nav-item" *ngIf="can('STORAGE_MONITOR_VIEW')">
							<a [routerLink]="['/storage-monitor']" class="nav-link" routerLinkActive="active"><i class="ph-hard-drives"></i>Storage Monitor</a>
						</li>
						<li class="nav-item" *ngIf="roles.includes('ADMIN')">
							<a [routerLink]="['/user']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
								<i class="ph-users"></i><span>Users</span>
							</a>
						</li>
						<li class="nav-item">
							<a [routerLink]="['/executions']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
								<i class="ph-app-window"></i>
								<span>Executions</span>
							</a>
						</li>
						<li class="nav-item">
							<a [routerLink]="['/webhooks']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
								<i class="ph-plugs-connected"></i><span>Webhooks</span>
							</a>
						</li>
					</ul>
				</li>

				<li class="nav-item">
					<a [routerLink]="['/help/getting-started']" class="nav-link" routerLinkActive="active" (click)="checkMenu()">
						<i class="ph-question"></i><span>Help</span>
					</a>
				</li>


			</ul>
			
			
	</div>
		</div>
		<!-- /main navigation -->
		 
	
	<!-- /sidebar content -->

	<div *ngIf="showPopup" class="card shadow position-fixed bottom-0 end-0 mb-5 me-3" style="width:300px;z-index:9999">
  
		<div class="card-header d-flex justify-content-between align-items-center">
			<span class="fw-semibold text-dark">System Info</span>
			<button class="btn-close btn-sm" (click)="togglePopup()"></button>
		</div>

		<div class="card-body p-0">
			<table class="table table-sm mb-0">
			<tbody>
				<tr *ngFor="let s of services">
				<td>{{s.service}}</td>
				<td><code>{{s.version}}</code></td>
				<td class="text-muted small">{{s.last_updated}}</td>
			</tr>
			</tbody>
			</table>
		</div>
		</div>
</div>
<!-- /main sidebar -->
